import { AxiosInstanceProvider } from '../../../core/hooks';
import { ItsmMaintenanceWorkApiModel } from '../../../itsm/model';
import { DashboardHttpQueryConfig } from '../../config';

export interface DashboardItsmMaintenanceWorksHttpGetPayloadModel {
  customerId: number;
}

export type DashboardItsmMaintenanceWorksHttpGetResponseModel = ItsmMaintenanceWorkApiModel[];

export const getDashboardItsmMaintenanceWorks = async (
  axios: AxiosInstanceProvider,
  { customerId }: DashboardItsmMaintenanceWorksHttpGetPayloadModel
): Promise<DashboardItsmMaintenanceWorksHttpGetResponseModel> => {
  const response = await axios().get<DashboardItsmMaintenanceWorksHttpGetResponseModel>(
    DashboardHttpQueryConfig['GetItsmMaintenanceWorks'].url.replace('{customerId}', customerId.toString(10)));
  return response.data;
};